import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { baseUrl, ipAddress, userName } from './Univ.js';

/* ---------------- DISTRICT LIST (HARDCODED) ---------------- */
const DISTRICTS = [
  'Chennai',
  'Chengalpattu',
  'Kancheepuram',
  'Thiruvallur',
  'Vellore',
  'Ranipet',
  'Tiruvannamalai',
  'Villupuram',
  'Cuddalore',
  'Mayiladuthurai',
  'Nagapattinam',
  'Thanjavur',
  'Tiruvarur',
  'Trichy',
  'Karur',
  'Perambalur',
  'Ariyalur',
  'Pudukkottai',
  'Madurai',
  'Theni',
  'Dindigul',
  'Virudhunagar',
  'Ramanathapuram',
  'Sivaganga',
  'Thoothukudi',
  'Tirunelveli',
  'Kanyakumari',
  'Salem',
  'Namakkal',
  'Erode',
  'Coimbatore',
  'Tiruppur',
  'Krishnagiri'
];

function AddConst() {

  const [cat, setCat] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [catData, setcatData] = useState({
    name: '',
    district: '',
    district_number: '',
    ac_number: '',
    total_voters: '',
    male_voters: '',
    female_voters: '',
    third_voters: '',
    status: '',
    addedby: '',
    ip_add: ''
  });

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (event) => {
    setcatData({
      ...catData,
      [event.target.name]: event.target.value
    });
  };

  /* ---------------- FORM SUBMIT ---------------- */
  const formSubmit = () => {
    const _formData = new FormData();
    _formData.append('name', catData.name);
    _formData.append('district', catData.district);
    _formData.append('ac_number', catData.ac_number);
    _formData.append('district_number', catData.district_number);
    _formData.append('total_voters', catData.total_voters);
    _formData.append('male_voters', catData.male_voters);
    _formData.append('female_voters', catData.female_voters);
    _formData.append('third_voters', catData.third_voters);
    _formData.append('status', '1');
    _formData.append('addedby', userName);
    _formData.append('ip_add', ipAddress);

    axios.post(baseUrl + 'constituencies/', _formData)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: 'Data has been added',
            icon: 'success',
            timer: 3000,
            showConfirmButton: false
          });
          window.location.reload();
        }
      })
      .catch(error => console.log(error));
  };

  /* ---------------- FETCH DATA ---------------- */
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setRows(cat);
  }, [cat]);

  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}constituencies/`)
      .then(response => {
        setCat(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    /* ---------------- DELETE ---------------- */
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure you want to delete this report?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + 'delete-const/' + id + '/')
          .then(() => {
            Swal.fire('Deleted', 'Report deleted', 'success');
            setTimeout(() => window.location.reload(), 1000);
          });
      }
    });
  };

  /* ---------------- DATAGRID COLUMNS ---------------- */
  const columns = [
    { field: 'id', headerName: 'ID', width: 50 },
    { field: 'district', headerName: 'District', width: 140 },
    { field: 'district_number', headerName: 'D.No', width: 50 },
    { field: 'name', headerName: 'Constituency', width: 180 },
    { field: 'ac_number', headerName: 'AC.No', width: 80 },
    { field: 'total_voters', headerName: 'Total Voters', width: 100 },
    { field: 'male_voters', headerName: 'Male Voters', width: 150 },
    { field: 'female_voters', headerName: 'Female Voters', width: 150 },
    { field: 'third_voters', headerName: 'Third Voters', width: 100 },


  ];

  /* ---------------- JSX ---------------- */
  return (
    <section className="container mt-4">

      <div className="row">
        <div className="col-md-9 col-12 mb-2">
          <div className="card">
            <h4 className="card-header">Add Constituency</h4>
            <div className="card-body">

              <form>
                <div className="mb-3">
                  <label className="form-label">District</label>
                  <select
                    className="form-control"
                    name="district"
                    value={catData.district}
                    onChange={handleChange}
                  >
                    <option value="">-- Select District --</option>
                    {DISTRICTS.map((d, i) => (
                      <option key={i} value={d}>{d}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">District Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="district_number"
                    value={catData.district_number}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Constituency</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={catData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">AC Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ac_number"
                    value={catData.ac_number}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Total Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="total_voters"
                    value={catData.total_voters}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Male Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="male_voters"
                    value={catData.male_voters}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Female Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="female_voters"
                    value={catData.female_voters}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Third Voters</label>
                  <input
                    type="number"
                    className="form-control"
                    name="third_voters"
                    value={catData.third_voters}
                    onChange={handleChange}
                  />
                </div>

                <button
                  type="button"
                  onClick={formSubmit}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>

        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}
            autoHeight
          />

      </div>

    </section>
  );
}

export default AddConst;
